import {
  PostAPI,
  PostAPIWithoutRequest,
  PostAPIWithoutRequestAndKeyData,
} from "src/components/api/helper/apiHelper";

export const Insert = async (request: string) => {
  return PostAPI(request, "RegisterPromotionalPartner/Insert");
};

export const Select = async () => {
  return PostAPIWithoutRequest("RegisterPromotionalPartner/Select");
};

export const Delete = async (request: string) => {
  return PostAPI(request, "RegisterPromotionalPartner/Delete");
};

export const Update = async (request: string) => {
  return PostAPI(request, "RegisterPromotionalPartner/Update");
};

export const SelectByID = async (request: string) => {
  return PostAPI(request, "RegisterPromotionalPartner/SelectByID");
};

export const ShowPromotionalPartnerDetails = async (request: string) => {
  return PostAPI(request, "RegisterPromotionalPartner/ShowPromotionalPartnerDetails");
};

export const PromotionalPartnerForDropdown = async () => {
  return PostAPIWithoutRequest("RegisterPromotionalPartner/PromotionalPartnerForDropdown");
};